export const windowUtils = {
  hostname: window.location.hostname as string,
  open: (location: string, target = '_blank') => window.open(location, target),
};
